document.addEventListener('DOMContentLoaded', function () {
    const slideTabs = document.querySelectorAll('.slide-tab');
    const slidesImage = document.querySelectorAll('.slick-slide');
    const prevArrow = document.querySelector('.prev-arrow');
    const nextArrow = document.querySelector('.next-arrow');
    let currentIndex = 0;

    function updateSlider(index) {
        // Remove active class from all tabs and slides
        slideTabs.forEach(t => t.classList.remove('active'));
        slidesImage.forEach(slide => {
            slide.classList.remove('active');
            slide.style.display = 'none';
        });

        // Add active class to current tab and slide
        slideTabs[index].classList.add('active');
        slidesImage[index].classList.add('active');
        slidesImage[index].style.display = 'block';
    }

    // Initialize slider
    if (slideTabs.length > 0 && slidesImage.length > 0) {
        updateSlider(currentIndex);

        // Tab click functionality
        slideTabs.forEach(tab => {
            tab.addEventListener('click', function (e) {
                e.preventDefault();
                currentIndex = parseInt(this.getAttribute('data-index'));
                updateSlider(currentIndex);
            });
        });

        // Arrow click functionality
        if(nextArrow){
            nextArrow.addEventListener('click', function () {
                currentIndex = (currentIndex + 1) % slidesImage.length; // Infinite loop
                updateSlider(currentIndex);
            });
        }

        if(nextArrow){
            prevArrow.addEventListener('click', function () {
                currentIndex = (currentIndex - 1 + slidesImage.length) % slidesImage.length; // Infinite loop
                updateSlider(currentIndex);
            });
        }
    }

     /*----------  Print Floor Plan  ----------*/
     const printPlan = document.querySelector('.print-plan');
     if(printPlan){
        printPlan.addEventListener('click', function(event) {
            event.preventDefault();
            const img_to_load = document.querySelector('.plan-slider .slick-slide.active a').getAttribute('href');
            printWindow = window.open(img_to_load, "popupWindow", 'printWindow');
        });
     }

        /*----------  Download Floor Plan  ----------*/

        const downloadPlan = document.querySelector('.download-plan');
        if(downloadPlan){
            downloadPlan.addEventListener('click', function(event) {
                event.preventDefault();
                let a_href = document.querySelector('.plan-slider .slick-slide.active a').getAttribute('href');
                a_href += "?view=download";
                window.location.href = a_href;
            });
        }

        /*---------- Flip all image  ----------*/

        const buttonFlipPlans = document.querySelector('.button-flip-all-plans');
        if(buttonFlipPlans){
            buttonFlipPlans.addEventListener('click', function(event) {
                const mediaWrapper = document.querySelector('.product__media-wrapper');
                mediaWrapper.classList.toggle('flip-all-image');
            });
        }

});
